import "./About.css"
import Emilio from "./Images/Emilio.JPG"
export default function About() {
    return (
        <div className="About-container">
        <h2 className="About-text">
        Milano's Masonry was founded in 2001 by Emilio. With over 20 years of experience, Emilio was able to grow the company and obtain a great pool of talent. The company currently has over 30 skilled employees all dedicated to their craft. Emilio prides himself in his hardworking employees who share the same values - creating high quality products and leaving our clients satisfied.
        </h2>

        <img src={Emilio} alt="Emilio.jpg" id="Emilio" />
        <p>Clients no longer just take a chance on Milano's Masonry - they are confident that relying on Milano's Masonry to build their most valued, high-profile projects is the best choice. Milano's Masonry has proven itself….repeatedly. The company continues to look to the future, bringing in new talent and adjusting company culture to suit the times in which we work. There’s new training, new technology, and there are new goals to exceed. Milano's Masonry continues to learn and improve so that the coming decades will be as successful as their first.</p>

      </div>
    );
  }